import { Route } from 'react-router-dom';
import { NotFound } from '../../pages/error/notFound';
import {
    ADMIN_PATH,
    FORBIDDEN_PATH,
    FORGOTTEN_PASSWORD_PATH,
    INTEGRATION_PATH,
    OUTPUT_REPORT_DETAIL_PATH,
    OUTPUT_REPORT_LIST_PATH,
    OUTPUT_REPORT_PATH,
    PARTICIPANT_PATH,
    PASSWORD_PATH,
    PROFILE_PATH,
    QUESTIONNAIRE_PATH,
    REGISTER_PATH,
    RESET_PASSWORD_PATH,
    RESET_PASSWORD_TOKEN_PATH,
    SIGN_IN_PATH,
    SIGN_IN_TOKEN_PATH,
} from '../../constants/route.constants';
import RoleBasedRoute from './RoleBasedRoute';
import PrivateRoute from './PrivateRoute';
import Questionnaire from '../../pages/Participant/Questionnaire/Questionnaire';
import ProfilePage from '../../pages/ProfilePage/ProfilePage';
import { ResetPassword } from '../../pages/Auth/ForgottenPassword/ResetPassword';
import SignInTokenPage from '../../pages/Auth/SignInPage/SignInTokenPage';
import OutputReportsPage from '../../pages/OutputReportsPage/OutputReportsPage';
import OutputReportPage from '../../pages/OutputReportPage/OutputReportPage';
import PasswordPage from '../../pages/PasswordPage/PasswordPage';
import ForbiddenPage from '../../pages/error/ForbiddenPage';
import RegistrationPage from '../../pages/Auth/RegistrationPage/RegistrationPage';
import DashboardPage from '../../pages/Participant/DashboardPage/DashboardPage';
import ResetTokenPage from '../../pages/Auth/ResetTokenPage/ResetTokenPage';
import AdminRoutes from '../../admin/AdminRoutes';
import AdminService from '../../common/services/AdminService';
import BaseLayout from '../../common/layout/BaseLayout/BaseLayout';
import IntegrationPage from '../../pages/IntegrationPage/IntegrationPage';
import SignInPage from '../../pages/Auth/SignInPage/SignInPage';
import ForgottenPasswordPage from '../../pages/Auth/ForgottenPassword/ForgottenPassword';
import SentryRoutes from './SentryRoutes';
import BaseRoute from './BaseRoute';
import { UserService } from '../../services/common/UserService';
import UserRoles from '../../common/constants/UserRoles';

export function AppRoutes() {
    return (
        <BaseLayout>
            <SentryRoutes>
                <Route
                    path="/"
                    element={
                        <BaseRoute>
                            <SignInPage />
                        </BaseRoute>
                    }
                />
                <Route
                    path={SIGN_IN_PATH}
                    element={
                        <BaseRoute>
                            <SignInPage />
                        </BaseRoute>
                    }
                />
                <Route
                    path={SIGN_IN_TOKEN_PATH}
                    element={
                        <BaseRoute>
                            <SignInTokenPage />
                        </BaseRoute>
                    }
                />

                <Route
                    path={FORGOTTEN_PASSWORD_PATH}
                    element={
                        <BaseRoute>
                            <ForgottenPasswordPage />
                        </BaseRoute>
                    }
                />
                <Route
                    path={RESET_PASSWORD_PATH}
                    element={
                        <BaseRoute>
                            <ResetTokenPage />
                        </BaseRoute>
                    }
                />
                <Route
                    path={RESET_PASSWORD_TOKEN_PATH}
                    element={
                        <BaseRoute>
                            <ResetPassword />
                        </BaseRoute>
                    }
                />

                <Route
                    path={REGISTER_PATH}
                    element={
                        <BaseRoute>
                            <RegistrationPage />
                        </BaseRoute>
                    }
                />
                <Route
                    path={PARTICIPANT_PATH}
                    element={
                        <BaseRoute>
                            <RoleBasedRoute
                                allowedRoles={[UserRoles.participant]}
                            >
                                <DashboardPage />
                            </RoleBasedRoute>
                        </BaseRoute>
                    }
                />
                <Route
                    path={OUTPUT_REPORT_PATH}
                    element={
                        <BaseRoute>
                            <RoleBasedRoute
                                allowedRoles={[UserRoles.participant]}
                            >
                                <OutputReportsPage />
                            </RoleBasedRoute>
                        </BaseRoute>
                    }
                />
                <Route
                    path={OUTPUT_REPORT_LIST_PATH}
                    element={
                        <BaseRoute>
                            <RoleBasedRoute
                                allowedRoles={[UserRoles.participant]}
                            >
                                <OutputReportsPage />
                            </RoleBasedRoute>
                        </BaseRoute>
                    }
                />
                <Route
                    path={OUTPUT_REPORT_DETAIL_PATH}
                    element={
                        <BaseRoute>
                            <RoleBasedRoute
                                allowedRoles={[UserRoles.participant]}
                            >
                                <OutputReportPage />
                            </RoleBasedRoute>
                        </BaseRoute>
                    }
                />
                <Route
                    path={QUESTIONNAIRE_PATH}
                    element={
                        <BaseRoute>
                            <PrivateRoute>
                                <Questionnaire />
                            </PrivateRoute>
                        </BaseRoute>
                    }
                />

                <Route
                    path={PROFILE_PATH}
                    element={
                        <BaseRoute>
                            <PrivateRoute>
                                <ProfilePage />
                            </PrivateRoute>
                        </BaseRoute>
                    }
                />

                {UserService.isAnonymous() !== true && (
                    <Route
                        path={PASSWORD_PATH}
                        element={
                            <RoleBasedRoute
                                allowedRoles={[UserRoles.participant]}
                            >
                                <PasswordPage />
                            </RoleBasedRoute>
                        }
                    />
                )}

                {AdminService.isAdminAllowed() && (
                    <Route
                        path={`${ADMIN_PATH}/*`}
                        element={
                            <BaseRoute>
                                <RoleBasedRoute
                                    allowedRoles={[UserRoles.manager]}
                                >
                                    <AdminRoutes />
                                </RoleBasedRoute>
                            </BaseRoute>
                        }
                    />
                )}
                <Route
                    path={INTEGRATION_PATH}
                    element={
                        <BaseRoute>
                            <IntegrationPage />
                        </BaseRoute>
                    }
                />
                <Route path={FORBIDDEN_PATH} element={<ForbiddenPage />} />
                <Route path="*" element={<NotFound />} />
            </SentryRoutes>
        </BaseLayout>
    );
}
